<app-skeleton [loading]="loading" height="140px">
    <app-source-detail [baseInfo]="baseInfo"
        [detail]="detail"
        [event]="item"
        [loading]="updateLoading"
        [showPercentBar]="false"
        icon="#infigo-portGroup"
    >
    </app-source-detail>
</app-skeleton>
